import { render, staticRenderFns } from "./BGlobalErrorMessage.vue?vue&type=template&id=4c73ca90&scoped=true"
import script from "./BGlobalErrorMessage.vue?vue&type=script&lang=js"
export * from "./BGlobalErrorMessage.vue?vue&type=script&lang=js"
import style0 from "./BGlobalErrorMessage.vue?vue&type=style&index=0&id=4c73ca90&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73ca90",
  null
  
)

export default component.exports